import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { Field } from 'react-final-form';

import FieldValue from 'components/FieldValue';
import FieldValues from 'components/FieldValues';

import { ProfileFieldName } from 'components/PersonForm/constants';

import { OnChange } from 'react-final-form-listeners';
import EntityTableRowNameCell from './components/EntityTableRowNameCell';
import EntityTableRowCheckBox from './components/EntityTableRowCheckBox';

interface Props {
    id: string;
    entityId: number;
}

export default function RenderEntityTableRow(props: Props): React.ReactElement {
    const { id, entityId } = props;

    return (
        <Table.Row textAlign="center">
            <FieldValue name="entityId">
                {(): React.ReactElement => (
                    <EntityTableRowNameCell entityId={entityId} />
                )}
            </FieldValue>

            <FieldValues
                fieldNames={[
                    ProfileFieldName.MOBILE_NUMBER as string,
                    ProfileFieldName.EMAIL as string
                ]}
            >
                {({ mobileNumber, email }): React.ReactElement => (
                    <React.Fragment>
                        <Table.Cell
                            className="events-table-cell-padding"
                            textAlign="center"
                        >
                            <Field
                                name={`${id}.isSubscribedToHarvestEmail`}
                                component={EntityTableRowCheckBox}
                                id={`${id}.isSubscribedToHarvestEmail`}
                                disabled={!email}
                            />

                            <Field name={`${id}.isSubscribedToHarvestEmail`}>
                                {({
                                    input: { value, onChange }
                                }): React.ReactElement => (
                                    <OnChange name={ProfileFieldName.EMAIL}>
                                        {(emailValue): void => {
                                            if (value && !emailValue) {
                                                onChange(false);
                                            }
                                        }}
                                    </OnChange>
                                )}
                            </Field>
                        </Table.Cell>

                        <Table.Cell
                            className="events-table-cell-padding"
                            textAlign="center"
                        >
                            <Field
                                name={`${id}.isSubscribedToHarvestSms`}
                                component={EntityTableRowCheckBox}
                                id={`${id}.isSubscribedToHarvestSms`}
                                disabled={!mobileNumber}
                            />

                            <Field name={`${id}.isSubscribedToHarvestSms`}>
                                {({
                                    input: { value, onChange }
                                }): React.ReactElement => (
                                    <OnChange
                                        name={ProfileFieldName.MOBILE_NUMBER}
                                    >
                                        {(mobileNumberValue): void => {
                                            if (value && !mobileNumberValue) {
                                                onChange(false);
                                            }
                                        }}
                                    </OnChange>
                                )}
                            </Field>
                        </Table.Cell>
                    </React.Fragment>
                )}
            </FieldValues>
        </Table.Row>
    );
}
